export default __webpack_public_path__ + "static/media/cart.87f42819.svg";